class choosePersonCtrl {
    constructor($scope, logger, httpRequest, $uibModalInstance, items1) {
        // 选中数据
        let _chooseList = []
        const disabledData = items1
        const modalData = ''
        $scope.chooseList = []
        $scope.modalData = {}
        $scope.chooseSearchVal = ''
        $scope.chooseSearchResult = []
        $scope.modalData.choosetype = '1'
        // 获取数据
        httpRequest.get_qryOrgRoleAndUser().then((res) => {
            // 机构树
            $scope.orgTree = setUniqueUserId(res.data.value)
            // 缓存原始列表
            _chooseList = getFlaterItem($scope.orgTree)

            const selectedArr = []
            // 不可选数据
            if (disabledData != '') {
                // 将已选择用户记录在选择审批人员中
                for (let i = 0; i < disabledData.length; i++) {
                    for (const j in $scope.orgTree) {
                        for (const z in $scope.orgTree[j].userList) {
                            if ($scope.orgTree[j].userList[z].userName == disabledData[i].objectName) {
                                $scope.orgTree[j].userList[z].selected = true
                                selectedArr.push($scope.orgTree[j].userList[z].uniqueUserId)
                            }
                        }
                    }
                }

                // const disabledArrLen = disabledArr.length
                // for (let i = 0; i < disabledArrLen; i++) {
                //     for (const a in _chooseList) {
                //         if (_chooseList[a].uniqueUserId == disabledArr[i]) {
                //             _chooseList[a].cbDisable = true
                //         }
                //     }
                // }
            }

            const selectedStr = selectedArr.join(',')
            $scope.selectedOrg = selectedStr
        })

        function setUniqueUserId(treeData) {
            // 设置唯一id
            const result = treeData
            for (const i in result) {
                if (result[i].userList) {
                    for (const a in result[i].userList) {
                        result[i].userList[a].uniqueUserId = `${result[i].roleId}_${result[i].userList[a].userId}`
                    }
                }
            }
            return result
        }

        function getFlaterItem(treeData) {
            // 展平数组
            const result = []
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].userList) {
                        recursionTree(nodes[i].userList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                if (item.uniqueUserId) {
                    result.push(item)
                }
            })
            return result
        }

        function getSelectedItem(treeData) {
            // 递归树 获取选中项返回展平数组
            const result = []
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].userList) {
                        recursionTree(nodes[i].userList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                if (item.uniqueUserId && item.selected == true) {
                    result.push(item)
                }
            })
            return result
        }

        // 对象数组针对某一对象属性去重
        function arrReduce(arr) {
            const obj = {}
            return arr.reduce((item, next) => {
                if (!obj[next.userId]) {
                    obj[next.userId] = true && item.push(next)
                }
                return item
            }, [])
        }

        // orgTree用户名一致项统一控制选择状态
        function sameUsernameCtl(node) {
            for (const i in $scope.orgTree) {
                for (const j in $scope.orgTree[i].userList) {
                    if ($scope.orgTree[i].userList[j].userId === node.userId) {
                        $scope.orgTree[i].userList[j].selected = node.selected
                    }
                }
            }
        }
        // 搜索变化
        $scope.chooseSearchValChange = function () {
            const chooseSearchArr = []
            _chooseList.map((item) => {
                if (item.realName.indexOf($scope.chooseSearchVal) > -1) {
                    chooseSearchArr.push(item)
                }
            })
            $scope.chooseSearchResult = arrReduce(chooseSearchArr)
        }

        // 变化
        $scope.chooseSearchSelect = function (node) {
            sameUsernameCtl(node)
            // id数据
            $scope.chooseList = getSelectedItem($scope.orgTree)
            const selectedArr = $scope.chooseList.map((item) => item.uniqueUserId)
            const selectedStr = selectedArr.join(',')
            $scope.selectedOrg = selectedStr
        }

        $scope.stChangeHandle = function (data) {
            // 表格数据
            $scope.chooseList = arrReduce(data)
            // id数据
            const selectedArr = data.map((item) => item.uniqueUserId)
            const selectedStr = selectedArr.join(',')
            $scope.selectedOrg = selectedStr
        }

        // 删除
        $scope.delChosenList = function (id, index) {
            const tmpId = id.slice(id.indexOf('_') + 1)
            let tmpSelId = ''
            // 删除表格数据
            $scope.chooseList.splice(index, 1)
            // 删除id
            const selectedArr = $scope.selectedOrg.split(',')


            const l = selectedArr.length
            for (let i = l; i > 0; i--) {
                tmpSelId = selectedArr[i - 1].slice(selectedArr[i - 1].indexOf('_') + 1)
                if (tmpSelId == tmpId) {
                    selectedArr.splice(i - 1, 1)
                }
            }
            const selectedStr = selectedArr.join(',')
            $scope.selectedOrg = selectedStr
            // $scope.$broadcast('selectedOrgChange', selectedStr);
        }


        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            // 返回数据
            const chooseListLen = $scope.chooseList.length
            if (chooseListLen <= 0) {
                logger.logError('审批人不能为空')
                return
            }
            for (let i = 0; i < chooseListLen; i++) {
                $scope.chooseList[i].chooseType = $scope.modalData.choosetype
                if ($scope.modalData.choosetype === '1') {
                    $scope.chooseList[i].chooseTypeText = '或签'
                } else {
                    $scope.chooseList[i].chooseTypeText = '会签'
                }
            }
            // 重新组装选中id
            const selectedUserIdArr = $scope.chooseList.map((item) => item.userId)
            const selectedUserId = selectedUserIdArr.join(',')
            console.log(selectedUserId)
            $uibModalInstance.close({
                selectedArr: selectedUserId,
                selectedList: $scope.chooseList,
                choosetype: $scope.modalData.choosetype,
            })
        }
    }
}


choosePersonCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$uibModalInstance', 'items1']
export default choosePersonCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/preWarn/choosePersonCtrl.js